import React, { Component } from 'react'
import styled, { css } from 'styled-components'
import { observer } from 'mobx-react'

import { flex } from '../styles'
import { store } from  '../lib/utils'
import Button from './Button'
import NavLink from './NavLink'
import { haveTokensCheckSubscription } from '../lib/gumroad'

const Outer = styled.div`
  ${ flex.centerBoth }
  height: 3.5rem;
  > * {
    margin-left: 1rem;
  }
  ${ props => props.homepage && css`
    z-index: 1;
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    animation: fade-in 0.6s ${props => props.theme.animating ? '2.9s' : '0s'} ease-out both;
  `}
`

const Message = styled.div`
  opacity: 0.8;
  font-size: 0.9em;
`

class TopRight extends Component {
  componentDidMount() {
    const { accessToken, refreshToken } = store.auth
    if (accessToken && refreshToken) {
      store.loginLoading = true
      haveTokensCheckSubscription(accessToken, refreshToken)
        .then(() => {
          store.loginLoading = false
        }, () => {
          store.loginLoading = false
          store.auth = {}
        })
    }
  }

  render() {
    return store.vimeoIds
      ? <Outer {...this.props}><NavLink light pink to="/members">View all episodes</NavLink></Outer>
      : store.loginLoading
        ? <Outer {...this.props}><Message>Logging in...</Message></Outer>
        : <Outer {...this.props}>
          <NavLink light pink to="/members">Login</NavLink>
          <Button small onClick={() => window.ga && window.ga('send', 'event', 'cta', 'click', 'topright')}
                  type="anchor" href="https://gum.co/frontendcenter" target="_blank">
            Subscribe
          </Button>
        </Outer>
  }
}

export default observer(TopRight)



/** WEBPACK FOOTER **
 ** ./src/components/TopRight.js
 **/